export enum RequiresAttentionStatusEnum {
  InProgress = 1,
  Resolved = 2
}

export const RequiresAttentionStatusOptions = [
{ id: 1, label: 'In Progress' },
{ id: 2, label: 'Resolved' }
];
